import styled from 'styled-components';

import { MOBILE_NAVIGATION_HEIGHT } from '@pkg/components/MainNavigationMobile/styles';

type FiltersListToggleMobileProps = {
    $removeNavigationBottomSpacing?: boolean;
};
export const FiltersListToggleMobile = styled.div<FiltersListToggleMobileProps>`
    position: fixed;
    bottom: ${({ $removeNavigationBottomSpacing }) =>
        $removeNavigationBottomSpacing ? 20 : MOBILE_NAVIGATION_HEIGHT + 20}px;
    right: 20px;
    z-index: 49;
`;
